import { render } from "./roleForm.vue?vue&type=template&id=9945c6a2&scoped=true"
import script from "./roleForm.vue?vue&type=script&lang=js"
export * from "./roleForm.vue?vue&type=script&lang=js"

import "./roleForm.vue?vue&type=style&index=0&id=9945c6a2&lang=less&scoped=true"
import "./roleForm.vue?vue&type=style&index=1&id=9945c6a2&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9945c6a2"]])

export default __exports__